import { EBitfStoreActions } from '@common/enums';
import { EContractStatus, ESpecificContractStatus } from '@web/enums/contract-status.enum';
import { EWorkOrderStatus } from './work-order-status.enum';

export enum EWebStoreActions {
  NEW_WEB_ACTION = 'NEW_WEB_ACTION',
  SET_GROUP = 'SET_GROUP',
}

export const eStoreActions = { ...EBitfStoreActions, ...EWebStoreActions };

export const eEntitiesStatus = { ...EWorkOrderStatus, ...EContractStatus, ...ESpecificContractStatus };
